<div id="doc-reader" class="fx-grow-1"></div>
